// extracted by mini-css-extract-plugin
export default {"wrapper":"MetricCard_wrapper__DLUKE","pinBtn":"MetricCard_pinBtn__t0epB"};